var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "22px",
    viewBox: "0 0 27 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lead-Detail-Documents",
    transform: "translate(-139.000000, -42.000000)",
    stroke: "#CBCBCB",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(143.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7777731,19.9999947 L17.7777731,17.7777731 C17.7777731,16.5990334 17.3095208,15.4685727 16.476026,14.6350779 C15.6425312,13.8015832 14.5120695,13.3333298 13.3333298,13.3333298 L4.44444327,13.3333298 C3.26570358,13.3333298 2.13524212,13.8015832 1.30174735,14.6350779 C0.468252575,15.4685727 2.27373675e-13,16.5990334 2.27373675e-13,17.7777731 L2.27373675e-13,19.9999947",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88888653,8.88888653 C6.43428817,8.88888653 4.44444327,6.89904163 4.44444327,4.44444327 C4.44444327,1.98984491 6.43428817,0 8.88888653,0 C11.3434849,0 13.3333298,1.98984491 13.3333298,4.44444327 C13.3333298,6.89904163 11.3434849,8.88888653 8.88888653,8.88888653 Z",
    id: "Vector"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientGray);
export default __webpack_public_path__ + "static/media/client-gray.7ad717c235d82fca5ad6622d9a45a1e8.svg";
export { ForwardRef as ReactComponent };